import SearchSales from './SearchSales';
export default SearchSales;
